// 详细信息

import axios from '@/util/request'

const prefix = '/api/v1/place'

export default {
  getPlaceMapForRecords: function () {
    return axios.get(`${prefix}/map_for_records`)
  },
  getPlaceList: function (param) {
    let query = Object.keys(param).map(k => k + '=' + param[k]).join('&')
    return axios.get(`${prefix}/list?${query}`)
  },
  getCityList: function () {
    return axios.get(`${prefix}/city_list`)
  }
}
